import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Helmet } from 'react-helmet';

import { getFormValues, destroy } from 'redux-form';

import Layout from 'components/common/Layout';
import Progress from 'components/common/Progress';
import Filter from 'components/common/Filter';
import TemplatesList from 'components/settings/TemplatesList';
import TemplateNameCreateDialog from 'components/settings/TemplateNameCreateDialog';

import { fetchTemplates } from 'redux/modules/templates';
import { fetchBusiness } from 'redux/modules/business';

import { getFilterChangeTypes } from 'utils/filterChangeTypes';
import throttle from 'utils/throttle';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class Templates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createDialogOpen: false,
      limit: 5,
      offset: 0,
      triggerLoading: true,
    };

    this.onCreateButtonClick = this.onCreateButtonClick.bind(this);
    this.onCreateDialogClose = this.onCreateDialogClose.bind(this);
    this.onWindowScroll = this.onWindowScroll.bind(this);
    this.onRequest = this.onRequest.bind(this);

    this.onThrottledRequest = throttle(this.onRequest, 2000, false, true);
  }

  componentDidMount() {
    this.props.actions.fetchBusiness({
      triggerLoading: true,
    });
    this.onRequest();
    window.addEventListener('scroll', this.onWindowScroll);
  }

  componentWillReceiveProps(nextProps) {
    const { count, loading, filters } = this.props;
    const filtersChanged = nextProps.filters.Name !== filters.Name;
    const newState = {};
    if (filtersChanged) {
      newState.offset = 0;
      newState.limit = 5;
    }
    if (count === 0) {
      newState.triggerLoading = true;
    } else {
      newState.triggerLoading = false;
    }
    if (nextProps.loading < loading) {
      newState.triggerLoading = false;
    }

    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    const { filters, templates, count, loading } = this.props;
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    const { throttledFiltersChanged, filtersChanged } = getFilterChangeTypes(
      prevProps.filters,
      filters,
      {
        textFilterKeys: ['Name'],
      },
    );

    if (throttledFiltersChanged) {
      this.onThrottledRequest();
    } else if (limitChanged || offsetChanged || filtersChanged) {
      this.onRequest();
    } else if (templates.length < count
      && loading === 0
      && !(window.scrollY || document.documentElement.scrollTop)) {
      this.onWindowScroll();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onWindowScroll);
  }

  onRequest() {
    const { actions, filters } = this.props;
    const { limit, offset, triggerLoading } = this.state;
    const requestFilters = filters && Object.keys(filters).length > 0
      ? Object.keys(filters).map(key => ({
        name: key,
        operation: 'startswith',
        val: filters[key],
        case_sensitivity: false,
      }))
      : null;
    actions.fetchTemplates({
      limit,
      offset,
      filters: requestFilters,
      triggerLoading,
      push: offset > 0,
    });
  }

  onWindowScroll() {
    const { offset, limit } = this.state;
    const scrollTop = window.scrollY
      ? window.scrollY : document.documentElement.scrollTop;
    if ((window.innerHeight + scrollTop) / document.body.scrollHeight > 0.7) {
      if ((this.props.templates.length - limit) >= offset) {
        this.setState({
          offset: offset + limit,
          limit: 6,
        });
      }
    }
  }

  onCreateButtonClick() {
    const { actions, form } = this.props;
    this.setState({ createDialogOpen: true });
    actions.destroy(form);
  }

  onCreateDialogClose() {
    this.setState({ createDialogOpen: false });
  }

  render() {
    const { templates, history, loading, form, business } = this.props;
    const { createDialogOpen } = this.state;

    return (
      <Layout variant="settings">
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Templates
          </title>
        </Helmet>
        <Filter
          form="templatesFilter"
          placeholder="Search Template"
        />
        {(loading > 0) ? (
          <Progress />
        ) : (
          <Fragment>
            <TemplatesList
              templates={templates}
              onCreateButtonClick={this.onCreateButtonClick}
              business={business}
            />
            <TemplateNameCreateDialog
              form={form}
              open={createDialogOpen}
              onClose={this.onCreateDialogClose}
              onSubmitSuccess={(values) => {
                history.push('/settings/templates/create', {
                  initialValues: values,
                });
              }}
            />
          </Fragment>
        )}
      </Layout>
    );
  }
}

Templates.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  loading: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    fetchTemplates: PropTypes.func.isRequired,
    destroy: PropTypes.func.isRequired,
    fetchBusiness: PropTypes.func.isRequired,
  }).isRequired,
  filters: PropTypes.shape({
    Name: PropTypes.string,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
    'Time Zone': PropTypes.string,
  }),
};

Templates.defaultProps = {
  business: {},
};

const mapStateToProps = (store) => {
  const templatesFilterValues = getFormValues('templatesFilter')(store);
  return {
    templates: store.templates.data,
    count: store.templates.count,
    loading: store.templates.loading + store.business.loading,
    business: store.business.data,
    filters: {
      ...templatesFilterValues && templatesFilterValues.Filter
        ? { Name: templatesFilterValues.Filter } : {},
    },
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchTemplates, fetchBusiness, destroy }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Templates);



// WEBPACK FOOTER //
// ./src/pages/settings/Templates.js